import 'angular-breadcrumb';
import 'add-to-homescreen';
import moment from 'moment';

const KEY_LASTSTATE = 'last_state';

export function ConfigRouteConfig(
  $urlRouterProvider,
  $compileProvider,
  $urlMatcherFactoryProvider,
  $breadcrumbProvider,
  $locationProvider,
) {
  'ngInject';

  $urlMatcherFactoryProvider.caseInsensitive(true);
  $urlMatcherFactoryProvider.strictMode(false);

  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('');

  $urlRouterProvider.otherwise(($injector) => {
    const $state = $injector.get('$state');
    const navService = $injector.get('navService');

    const firstAccessibleTopNav = navService.getFirstValidTopNavItem();

    if (firstAccessibleTopNav) {
      $state.go(firstAccessibleTopNav.sref);
    }
  });

  // set this to false for significant performance boost in production, but enabled when using debugging tools for angular in devmode
  $compileProvider.debugInfoEnabled(true);

  $urlMatcherFactoryProvider.type('timeStamp', {
    name: 'timeStamp',
    decode: (myDateValue) => {
      let timestamp;

      if (myDateValue instanceof Date) {
        return myDateValue;
      }

      timestamp = Date.parse(myDateValue);

      if (timestamp) {
        return moment(timestamp);
      }
    },
    /**
     * Detects whether a value is of a particular type. Accepts a native (decoded) value and determines whether
     * it matches the current Type object.
     * @see https://ui-router.github.io/ng1/docs/0.3.1/index.html#/api/ui.router
     * @see http://stackoverflow.com/questions/32867815/can-i-pass-datetime-parameters-in-ui-router
     */
    is: (myDateValue) => {
      return myDateValue && this.decode(myDateValue) === myDateValue;
    },
  });

  $breadcrumbProvider.setOptions({
    template:
      '<ol class="breadcrumb">' +
      '<li ng-repeat="step in steps | limitTo:(steps.length-1)">' +
      '<a ui-sref="{{step.ncyBreadcrumbSref}}" ng-bind-html="step.ncyBreadcrumbLabel"></a>' +
      '</li>' +
      '<li ng-repeat="step in steps | limitTo:-1" class="active">' +
      '<span ng-bind-html="step.ncyBreadcrumbLabel"></span>' +
      '</li>' +
      '</ol>',
  });
}

export function ConfigRunSetup(
  $rootScope,
  $state,
  $location,
  navService,
  localStorageService,
  editableOptions,
  $ngRedux,
) {
  'ngInject';

  // Theme settings for x-editable form
  editableOptions.theme = 'bs3';

  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams) => {
    const lastStateParams = {
      state: toState.name,
      params: toParams,
      timestamp: moment().format(),
    };

    if (toState.name !== 'index') {
      localStorageService.set(KEY_LASTSTATE, lastStateParams);
    }

    $rootScope.flexPage = toState.data && toState.data.flex;
    $rootScope.leftNav = toState.data && toState.data.leftNav;
    $rootScope.breadcrumb = toState.data && toState.data.breadcrumb;
  });

  $rootScope.$on('$stateChangeStart', (evt, to, params) => {
    const nextState = (name, param) => ({ name, params: param });

    const GetValidSubItemOrUnauthorized = (stateName) => {
      const validSubItem = navService.getFirstValidSubItemState(stateName);
      return validSubItem ? nextState(validSubItem.sref) : nextState('unauthorized');
    };

    const redirectTo = (state) => {
      return $state.go(state.name, state.params);
    };

    // Make sure that we hide the menus every time we change state
    navService.hideSideNav();

    if (to.redirectTo || !navService.isValidState(to.name)) {
      evt.preventDefault();

      if (to.redirectTo && navService.isValidState(to.redirectTo)) {
        return redirectTo(nextState(to.redirectTo, params));
      }

      return redirectTo(GetValidSubItemOrUnauthorized(to.name));
    }

    // pop up message to add bookmark to ios devices home screen
    // eslint-disable-next-line no-undef
    addToHomescreen({
      startDelay: 5,
    });
  });

  // send user to his prefferd landing page
  const reduxState = $ngRedux.getState();

  // we are not going to use document.referrer now, as it is always return referredFromAuthServer when referesh
  // todo(why): the line to update referrer at the bottom is working, but login server as referrer url coming back on refresh!
  // const referredFromAuthServer = document.referrer.includes(process.env.AUTH_SERVER_URL);

  const { href = '' } = document.location;
  const hereFromAuth = href.includes('/home/id_token=');

  if (hereFromAuth) {
    const {
      app: { redirectToState = null },
    } = reduxState;

    const signInRedirectUri = localStorage.getItem('sign-in-redirect-uri');
    let url = null;

    if (signInRedirectUri !== null) {
      localStorage.removeItem('sign-in-redirect-uri');
      const match = /\/home\/(.*)/.exec(signInRedirectUri);
      [, url] = match;
    }

    if (url) {
      Object.defineProperty(document, 'referrer', { get: () => window.location.href });
      $location.url(url);
    } else if (redirectToState && navService.isValidState(redirectToState)) {
      // This code prevents the referrer from getting in a loop and _always_ being from the login server
      // because angular is an SPA
      Object.defineProperty(document, 'referrer', { get: () => window.location.href });
      $state.go(redirectToState);
    }
  }
}
